import React, { Suspense, useEffect, useState } from "react";
import GenericTabs from "../../genericComponents/GenericTabs";
import { useSelector } from "react-redux";
import CustomTabs from "../CustomTabs/CustomTabs";
import { useSearchParams } from "react-router-dom";

const DocumentsV3 = React.lazy(() => import("../Documents/DocumentsV3"));
const Financials = React.lazy(() => import("../Financials/Financials"));

function MoreComps({ handleTabChange }) {

    const { dynamicTabsData } = useSelector(state => state.dynamicTabsReducer);
    const [tabsToRender,setTabsToRender]=useState([])
    const [searchParams, setSearchParams] = useSearchParams();
      useEffect(() => {
        if (searchParams.get("subTab") == "financial") {
          setSearchParams({
            tab: "more",
            subTab: "financial",
          });
        } else {
          setSearchParams({
            tab: "more",
             // subTab: "business",
             subTab: "documents",
          });
        }
      }, []);

  useEffect(() => {
    
    const tabData = [
        // {
        //   tabId:"business",
        //   label: "Business Segments",
        //   comp: (
        //     <BusinessSegments
        //       active_tab_key={"business"}
        //       account_contacts_data={accountContactList}
        //     />
        //   ),
        // },
        // { tabId:"growth", label: "Growth Opportunities", comp: <GrowthOpportunities active_tab_key={"growth"}/> },
        { tabId:"documents",label: "Documents", comp: <DocumentsV3 active_tab_key={"documents"} /> },
        // { tabId:"contacts",label: "Contacts", comp: <Contacts account_contacts_data={accountContactList} loader={account_contacts_loading} />},
        // { tabId:"competitor_insights",label: "Competitor Analysis", comp:<CompetitorInsights/>},
        // { tabId:"technology",label: "Tech Landscape", comp:<TechnologyLandscape/>},
        { tabId:"financial",label: "Financials", comp: <Financials/> },
        // { tabId:"agents",label: "Agents", comp:<Agents/>}
      ];


      dynamicTabsData.forEach(item=>tabData.push({label:item?.
        tab_name , comp:<CustomTabs content={item?.content}/>
        }))
        setTabsToRender(tabData)

  }, [dynamicTabsData])
  

  return <Suspense fallback={<div>Loading...</div>}><GenericTabs tabs={tabsToRender} handleTabChange={handleTabChange} /></Suspense>;
}

export default MoreComps;
